
import { baseApi } from 'segments/api/baseApi';
import { ToSnakeCase } from 'segments/types/transformTypes';
import { camelToSnakeCase } from 'segments/utils/helpers/transforms';


import { adapteTransactionsList } from '../utils/adapter';

import type {
  GetTransactionsParams,
  TransactionsList,
} from './types';

export const api = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getTransactions: builder.query<TransactionsList, GetTransactionsParams>({
      query: (formData) => ({
        url: '/admin/transactions/list',
        params: camelToSnakeCase<GetTransactionsParams, ToSnakeCase<GetTransactionsParams>>(formData),
      }),
      transformResponse: adapteTransactionsList,
      providesTags: ['Transactions'],
      keepUnusedDataFor: 1,
    }),
  }),
});

export const {
  useGetTransactionsQuery,
} = api;
